import { WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';
import { config } from '../config';

// react-oidc-context configuration. PKCE is enabled automatically because no
// client_secret is provided (User Agent OIDC apps in Zitadel run public PKCE).
//
// Refresh tokens are kept in sessionStorage rather than localStorage so a tab
// close ends the session. Move to httpOnly cookies in a later phase if the
// threat model demands it (requires a backend session cookie endpoint).
//
// E2E mode (config.e2eDevToken set): silent renew is disabled and userinfo
// loading is off so the library never tries to talk to Zitadel. main.tsx
// pre-seeds sessionStorage with a synthetic User so isAuthenticated=true
// from the first render.
const isE2E = config.e2eDevToken !== null;

export const oidcConfig: AuthProviderProps = {
  authority: config.authIssuer,
  client_id: config.authClientID,
  redirect_uri: `${window.location.origin}/auth/callback`,
  // Trailing slash matters — Zitadel does exact-string matching against the
  // app's registered postLogoutRedirectUris, and bootstrap registers the
  // origin with a trailing "/". Drop the slash and end_session returns
  // post_logout_redirect_uri invalid.
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email offline_access',
  automaticSilentRenew: !isE2E,
  loadUserInfo: !isE2E,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  // After the OIDC library finishes processing the callback URL, drop the
  // `code` and `state` query params so the URL is clean.
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
